export default {
    "/": {
        "title": "Taoify - Nền tảng xây dựng trang web thương mại điện tử xuyên biên giới | Hàng Trung Quốc, bán toàn cầu",
        "desc": "Taoify tích hợp xây dựng trang web, dịch thuật, đăng sản phẩm, logistics, thanh toán và tiếp thị vào một hệ thống quản lý: 18 nhân viên AI giúp bạn làm việc, mở cửa hàng bằng 20 ngôn ngữ, bán hàng Trung Quốc khắp thế giới."
    },
    "/feature": {
        "title": "Chức năng · Tất cả những gì cần để mở cửa hàng, đều có trên trang này · Taoify",
        "desc": "Xây dựng trang web, dịch thuật, đăng sản phẩm, giao hàng, thanh toán, thu hút khách hàng — Taoify đưa 15 module cần thiết cho bán hàng xuyên biên giới vào một hệ thống, không cần phải sử dụng nhiều công cụ khác nhau."
    },
    "/ai-staff": {
        "title": "Nhân viên AI · 18 nhân viên AI, nhóm tăng trưởng là bận rộn nhất · Taoify",
        "desc": "Trong 18 nhân viên AI, 5 thành viên của nhóm tăng trưởng chuyên giải quyết vấn đề 'không có ai đến': 12 hạng mục kiểm tra cửa hàng, kế hoạch tiếp thị 30 ngày, chỉnh sửa một sản phẩm thành 9 phiên bản cho các kênh khác nhau, email tiếp thị tự động gọi khách hàng quay lại."
    },
    "/logistics": {
        "title": "Logistics xuyên biên giới · Từ tay bạn đến tay khách hàng · Taoify",
        "desc": "Vận chuyển đầu, thông quan, vận chuyển chính, giao hàng cuối cùng, ba tuyến đường tùy chọn theo loại hàng và thời gian. Cloudway, Yanwen, 4PX đã được kết nối, nhãn vận đơn, theo dõi và xử lý sự cố đều trong một hệ thống."
    },
    "/payment": {
        "title": "Thanh toán và thanh toán · Khách hàng thanh toán theo cách thuận tiện nhất · Taoify",
        "desc": "PayPal, Stripe, thẻ tín dụng, Alipay sẵn sàng sử dụng. Nhận ngoại tệ, rút tiền Nhân dân tệ, thanh toán T+7, phí và thời gian nhận tiền được công khai."
    },
    "/pricing": {
        "title": "Giá · Gói đăng ký + hoa hồng bậc thang · Taoify",
        "desc": "Cửa hàng tính phí theo gói đăng ký: Basic $15/tháng, Standard $29/tháng, Premium $59/tháng, tiết kiệm hơn khi thanh toán theo quý hoặc năm. Hoa hồng giao dịch theo doanh số tháng, thấp nhất 3%."
    },
    "/cases": {
        "title": "Câu chuyện của người bán · Họ cũng đang làm điều tương tự · Taoify",
        "desc": "Phụ kiện từ Yiwu, thiết bị 3C từ Shenzhen, quần áo từ Quảng Châu, và các nhà bán hàng từ Đức, Mỹ, Pháp - sáu người, sáu điểm xuất phát, cùng một phương pháp."
    },
    "/sign-up": {
        "title": "Mở cửa hàng - Đăng ký miễn phí với Taoify",
        "desc": "Xây dựng trang web thương hiệu riêng trong 10 phút, không cần mã hóa, dùng thử toàn bộ chức năng gói đăng ký, chuỗi khép kín. Đăng ký ngay Taoify để bắt đầu hành trình thương mại điện tử xuyên biên giới."
    },
    "/for-china-sellers": {
        "title": "Dành cho người bán Trung Quốc · Bạn chỉ cần chọn sản phẩm và định giá, phần còn lại để chúng tôi lo · Taoify",
        "desc": "Xây dựng trang web, dịch thuật, vận chuyển, in nhãn, trả lời khách hàng - những việc rắc rối giữa quá trình bán hàng xuyên biên giới, nền tảng sẽ giúp bạn. Gói đăng ký + hoa hồng theo bậc (thấp nhất 3%)."
    },
    "/for-global-sellers": {
        "title": "Dành cho người bán nước ngoài: Chọn sản phẩm từ kệ hàng Trung Quốc, bán trên cửa hàng của bạn · Taoify",
        "desc": "Không cần trữ hàng, không cần tồn kho: Chọn sản phẩm từ chuỗi cung ứng Trung Quốc, sau khi khách hàng đặt hàng, hàng sẽ được gửi trực tiếp từ kho ở Trung Quốc, bạn kiếm lợi nhuận từ chênh lệch. BuyLink còn có thể biến liên kết 1688, Taobao thành sản phẩm của bạn."
    },
    "/template-index": {
        "title": "Thị trường mẫu - Mẫu chủ đề chuyên nghiệp của Taoify",
        "desc": "Mẫu chủ đề chuyên nghiệp phù hợp với mọi dự án, hàng loạt mẫu ngành nghề miễn phí sử dụng, tùy chỉnh hình ảnh và chức năng theo nhu cầu."
    },
    "/question": {
        "title": "Trung tâm hỗ trợ · Có vấn đề, hãy tìm ở đây trước · Taoify",
        "desc": "Mở cửa hàng, trang trí, lên kệ, đơn hàng và vận chuyển, thanh toán, tiếp thị, quyền tài khoản - câu hỏi thường gặp được sắp xếp theo danh mục, nếu không tìm thấy, hãy tạo vé hỗ trợ."
    },
    "/about-us": {
        "title": "Về Taoify · Chúng tôi đang làm gì",
        "desc": "Taoify là nền tảng xây dựng trang web toàn diện cho các nhà bán hàng xuyên biên giới: Xây dựng trang web, dịch thuật, đăng sản phẩm, vận chuyển, thanh toán và tiếp thị đều được thực hiện trong một hệ thống quản lý duy nhất."
    },
    "/privacy-policy": {
        "title": "Chính sách bảo mật · Taoify",
        "desc": "Taoify thu thập, sử dụng, lưu trữ và bảo vệ thông tin cá nhân của bạn như thế nào, cũng như quyền mà bạn có đối với dữ liệu của mình."
    },
    "/terms-service": {
        "title": "Điều khoản Dịch vụ · Taoify",
        "desc": "Điều khoản và điều kiện khi sử dụng dịch vụ nền tảng Taoify: tài khoản, cửa hàng, đơn đặt hàng, thanh toán và phân chia trách nhiệm."
    },
    "/consumer-agreement": {
        "title": "Chính sách hoàn tiền · Taoify",
        "desc": "Quy định về hoàn tiền và hậu mãi cho đơn hàng trên nền tảng Taoify: Điều kiện áp dụng, thời gian xử lý và phương thức nhận tiền."
    },
    "/user-agreement": {
        "title": "Điều khoản sử dụng · Taoify",
        "desc": "Hãy đọc kỹ: Hướng dẫn đăng ký tài khoản, quy tắc kinh doanh và mô tả dịch vụ nền tảng trước khi đăng ký và sử dụng Taoify."
    }
}
